module.exports = __webpack_public_path__ + "static/media/raygun.4823e736.svg";